import { Component, OnInit, Input } from '@angular/core';
import { FLIP_IN_X, FLIP_IN_Y } from '../../animations/flip-in.animation';
import { MatDialog } from '@angular/material/dialog';
import { CreateAccountComponent } from '../create-account/create-account.component';
import { Router } from '../../../../node_modules/@angular/router';

@Component({
  selector: 's18-pricing',
  templateUrl: './pricing.component.html',
  styleUrls: ['./pricing.component.scss'],
  animations: [ FLIP_IN_X, FLIP_IN_Y ]
})
export class PricingComponent implements OnInit {
  @Input() animate: boolean = true;

  constructor(
    private dialog : MatDialog,
    private rounter: Router
  ) { }

  ngOnInit() {

  }

  animatePricing(){
    if ( this.animate ){
      return 'on';
    }
    return 'off';
  }
  
  joinNow(){
    var dialogRef = this.dialog.open( CreateAccountComponent, {width: "350px"});
  }

  joinNowLeague(){
    this.rounter.navigateByUrl("/register/league");
  }
  createTourneyNow() {
    this.rounter.navigateByUrl("/register/tournament");
  }
  createTripNow(){
    this.rounter.navigateByUrl("/register/trip");
  }

}
